import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import $ from 'jquery';
import {
    openMobilePlayerListing,
    setHighlight,
    makeCaptain,
    removePlayer,
    setManageTeamTutorialCookie,
    addOrRemovePlayer,
    triggerHandlePlayerCard,
    setManageTeamMode,
} from './../../actions/FormationActions';
import {
    initiateSubstitution,
} from './../../actions/ManageTeamActions';
import {
    resetAllFilters,
} from './../../actions/FilterActions';
import common from '../../common';
import config from "../../config";
import {
    getState,
    canPlayerSubstitute,
    getPlayerByKeyFromTeamData,
} from "../../helper";
import OutsideNotifier from '../../OutsideNotifier';

class JerseyManageTeam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toShowCaptainInfo: false,
            selectedJersey: null,
            playerStatusIconClicked: false,
        };
        this.timeout = null;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.player.id === null) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        }
    }

    changeManageTeamView = (e, removeThis, mode, player, objKey, playerIndex) => {
        e.stopPropagation();
        this.props.resetAllFilters();
        this.props.setManageTeamMode(mode);
        if (mode === config.modes["substitution"]) {
            // common.customTracking('Substitute Player - Tooltip');
            this.props.initiateSubstitution(player);
        } else {
            if (removeThis) {
                this.onRemoveTap(e, player, objKey, playerIndex);
            }
        }
    };
    onPlayerStatusIconClicked = (e, player) => {
        e.stopPropagation();
        if (this.state.playerStatusIconClicked) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        } else {
            this.setState({ selectedJersey: player.id, playerStatusIconClicked: true });
        }
    };
    onJerseyClick = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        if (this.state.playerStatusIconClicked) {
            this.setState({ playerStatusIconClicked: false });
        }
        if (player.id === null) {
            this.props.setHighlight({ player, objKey, playerIndex });
            if (config.isMobile) {
                if (!this.props.mobilePlayerListingOpen) {
                    this.props.openMobilePlayerListing(true);
                }
            }
        } else {
            if (this.props.manageTeamMode === config.modes["view-manage-team"]) {
                this.setState({ selectedJersey: player.id });
                this.onJerseyTapToAnimate(e);
            }
            if (this.props.manageTeamMode === config.modes["transfer"]) {
                // common.customTracking('Player Card - Tooltip');
                this.setState({ selectedJersey: player.id, playerStatusIconClicked: false });

                this.props.triggerHandlePlayerCard(true, player.details);
            }
        }
    };
    onFocusLost = () => {
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    };
    onFocusLostCaptainTooltip = () => {
        this.setState({ toShowCaptainInfo: false, selectedJersey: null, playerStatusIconClicked: false });
    };
    onInfoTap = (e, player, oldPlayer) => {
        e.stopPropagation();
        // common.customTracking('Player Card - Info icon');
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        if (player && Object.keys(player).length) {
            // if (config.isMobile) {
            this.props.triggerHandlePlayerCard(true, player);
            // }
        } else {
            // and show empty player with view players button

            this.props.triggerHandlePlayerCard(true, oldPlayer.DBDetails);
        }
    };
    onMakeCaptainTap = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        common.customTracking('Captain Player - Tooltip');
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        this.props.captainChangePopup(player.id);
    };
    onRevertPlayer = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        if (common.isMobile()) {

            // common.customTracking('Player Card - Tooltip');
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
            if (player && Object.keys(player).length) {
                this.props.triggerHandlePlayerCard(true, player);
                // }
            } else {
                // and show empty player with view players button
                this.props.triggerHandlePlayerCard(true, player);
            }
        } else {
            common.customTracking('Recover - Pitch');
            this.props.removePlayer({ player, objKey, playerIndex });
        }
    };

    componentWillUnmount() {
        clearTimeout(this.timeout);
        this.setState({ toShowCaptainInfo: false, selectedJersey: null, playerStatusIconClicked: false });
    }

    componentDidMount() {
        const that = this;
        const hasManageView = (that.props.manageTeamMode === config.modes["view-manage-team"]);
        const objKey = that.props.objKey;
        const playerIndex = that.props.index;
        const tutorialFirstTime = hasManageView && !that.props.hasSeenManageTeamTutorial && (playerIndex === 0 && objKey === '4');
        clearTimeout(that.timeout);
        if (tutorialFirstTime) {
            that.timeout = setTimeout(() => {
                that.props.setManageTeamTutorialCookie();
                that.setState({ selectedJersey: null });
            }, 5000);
        }
    }

    onRemoveTap = (e, player, objKey, playerIndex) => {
        // e.stopPropagation();
        // common.customTracking('Remove Player - Tooltip');
        // this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        // this.props.removePlayer({ player, objKey, playerIndex });
        e.stopPropagation();
        // common.customTracking('Remove Player - Tooltip');
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        if (common.isMobile()) {
            this.props.triggerHandlePlayerCard(true, player);
        } else {
            this.props.removePlayer({ player, objKey, playerIndex });
        }
    };
    animateView = (target) => {
        if (target.length === 0) return;
        const BUFFER = 30;
        const topValue = $(target).offset().top - $('.si-actions-strip-sticky').height() - ($('.si-actions-tooltip').outerHeight() || 0) - BUFFER;
        $('html,body').animate({
            scrollTop: topValue
        }, 500);
    };
    onJerseyTapToAnimate = (e) => {
        if (this.props.mobilePlayerListingOpen) {
            const tooltipElem = $(e.target).closest('.si-plyr-wrap');
            setTimeout(() => {
                (config.isMobile) && this.animateView(tooltipElem);
            }, 0);
        }
    };
    getTooltipMarkup = (player, tooltipClass, objKey, playerIndex) => {
        const { userSpecificFixtures, currentActiveFixture } = this.props;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        let getViewState = "";
        if (currentFixture) {
            getViewState = getState(currentFixture);
        }

        const { isCaptain, isBench } = player;
        const canBeSubstitute = this.canSubstitute(player);
        const captainObj = getPlayerByKeyFromTeamData(this.props.teamData, 'isCaptain', true);
        const captainHasRedCard = captainObj.data && captainObj.data.DBDetails && captainObj.data.DBDetails.IsRedCard;
        // const canBeCaptain = !captainHasRedCard && (player.DBDetails.IsPlayed !== 1) && !isBench && !isCaptain;
        const canBeCaptain = (player.DBDetails.IsPlayed !== 1) && !isBench && !isCaptain;

        /* tooltip buttons */
        let captainMarkup = (canBeCaptain) ?
            <span
                onClick={ (e) => this.onMakeCaptainTap(e, player, objKey, playerIndex) }>{ this.props.trans['captain'] }</span>
            : null;
        let infoButton = <span onClick={ (e) => this.onInfoTap(e, player.details, player) }>{ this.props.trans.info }</span>
        let substitute = (canBeSubstitute && (getViewState === config.possibleActions["substitution"] || getViewState === config.possibleActions["subsAndTransfer"])) ?
            <span
                onClick={ (e) => this.changeManageTeamView(e, false, config.modes.substitution, player) }>{ this.props.trans.substitutePc }</span> : null;
        let transfer = (getViewState === config.possibleActions["transfer"] || getViewState === config.possibleActions["subsAndTransfer"]) ?
            <span
                onClick={ (e) => this.changeManageTeamView(e, true, config.modes.transfer, player.details, objKey, playerIndex) }>{ this.props.trans.transfer }</span> : null;
        return <div className={ "si-tooltip si-actions-tooltip " + tooltipClass + " si-flexBox" }>
            { infoButton }
            { captainMarkup }
            { transfer }
            { substitute }
        </div>
    };
    canSubstitute = (player) => {
        const substituteThisPlyr = canPlayerSubstitute(player);
        return substituteThisPlyr;
    };

    render() {
        const location = this.props.location;
        const player = this.props.player;
        const { IsFixtureUpdated } = this.props.constraints;
        const isFixtureUpdated = (IsFixtureUpdated === 1 || IsFixtureUpdated === "1");
        const objKey = this.props.objKey;
        const isLast = this.props.position;
        const playerIndex = this.props.index;
        const isHighlighted = player.isHighlighted;
        const isCaptain = player.isCaptain;
        const isBench = player.isBench;
        const selectedJersey = this.state.selectedJersey;
        const currentStep = getStep(location.pathname);
        const isPlayerSelected = selectedJersey === player.id;
        const showIconTooltip = isPlayerSelected && this.state.playerStatusIconClicked;
        const hasManageView = (this.props.manageTeamMode === config.modes["view-manage-team"]);
        const hasTransferView = (this.props.manageTeamMode === config.modes["transfer"]);
        const moreOptions = (hasManageView) && selectedJersey && isPlayerSelected && !showIconTooltip;
        const captainTooltip = this.state.toShowCaptainInfo && isCaptain;
        const tutorialFirstTime = hasManageView && !this.props.hasSeenManageTeamTutorial && (playerIndex === 0 && objKey === '4');
        const tooltipClassFirstTime = common.makeClasses({
            'si-tooltip': true,
            'si-actions-tooltip': true,
            'si-flexBox': true,
            'si-left-tt': common.isMobile()
        });
        const dataWrapClass = common.makeClasses({
            'si-data-wrap': true,
            'si-more-opts': ((hasManageView) && (moreOptions || captainTooltip || tutorialFirstTime))
        });
        const teamImg = config.playerImgBase + `player-jersey/${(player.details.Skill === 1) ? 'GK/' : ''}${player.details['TID']}.png`;
        const tutorialTooltip = <OutsideNotifier handler={ this.props.setManageTeamTutorialCookie.bind(this) }>
            <div className={ tooltipClassFirstTime }>
                <span>{ this.props.trans['manageTeamTutorial'] }</span>
            </div>
        </OutsideNotifier>;
        const jerseyClassName = common.makeClasses({
            'si-plyr-wrap': true,
            'si-selected': true,
            'si-current': config.isMobile ? (isHighlighted && this.props.mobilePlayerListingOpen) : isHighlighted,
            'si-first-tutorial': tutorialFirstTime,
            'si-recovered-plyr': hasTransferView && ((player.id === null) && player.DBDetails),
            'si-new-plyr': hasTransferView && player.isNew
        });
        let clickHandler = {
            onClick: () => { }
        };
        const isManageTeamStep = currentStep === 0 && common.isManageTeam();
        if (isManageTeamStep && tutorialFirstTime) {
            clickHandler = { onClick: this.props.setManageTeamTutorialCookie.bind(this) };
        } else if (isManageTeamStep) {
            if (config.isMobile) {
                clickHandler = { onClick: (e) => this.onJerseyClick(e, player, objKey, playerIndex) };
            } else {
                clickHandler = { onClick: (e) => this.onInfoTap(e, player.details, player) };
            }
        } else if (!isManageTeamStep) {
            clickHandler = { onClick: (e) => this.onMakeCaptainTap(e, player, objKey, playerIndex) };
        }
        clickHandler = { onClick: (e) => this.onInfoTap(e, player.details, player) };
        let playerActionIcon = null;
        let subPos = null;
        if (hasTransferView) {
            if (player.id === null) {
                playerActionIcon = <span className="si-icons si-ucl-recover">
                    <i className="si-recover-icon icon-ucl-recover"
                        onClick={ (e) => this.onRevertPlayer(e, player.DBDetails, objKey, playerIndex) } />
                </span>;
            } else {
                playerActionIcon = <span className="si-icons">
                    <i className="si-remove-player icon-ucl-close"
                        onClick={ (e) => this.onRemoveTap(e, player.details, objKey, playerIndex) } >
                        <div className="si-tooltip si-status-tooltip si-tt">
                            <span>{ this.props.trans['transferOutTT'] || "Transfer Out" }</span>
                        </div>
                    </i>
                </span>;
            }
            subPos = isBench ? <div className="si-subs-pos">
                <span>{ playerIndex > 0 ? (playerIndex + '.') : null } { this.props.trans['short' + (player.details.Skill ? player.details.Skill : player.DBDetails.Skill)] }</span>
            </div> : null;
        } else if (hasManageView) {
            const { userSpecificFixtures, currentActiveFixture } = this.props;
            if (userSpecificFixtures.length === 0) return null;
            const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
            let getViewState = "";
            if (currentFixture) {
                getViewState = getState(currentFixture);
            }

            const isSubsAllow = (getViewState === config.possibleActions["substitution"] || getViewState === config.possibleActions["subsAndTransfer"]);
            const canSubstitute = isSubsAllow && isBench && this.canSubstitute(player);
            if (canSubstitute) {
                playerActionIcon = <span className="si-icons">
                    <i className="si-sub-player icon-ucl-subsitute" onClick={ (e) => { e.stopPropagation(); this.changeManageTeamView(e, false, config.modes.substitution, player) } }>
                        <div className="si-tooltip si-status-tooltip si-tt">
                            <span>{ this.props.trans['substitute'] || "Substitute" }</span>
                        </div>
                    </i>
                </span>

            }
            subPos = isBench ? <div className="si-subs-pos">
                <span>{ playerIndex > 0 ? (playerIndex + '.') : null } { this.props.trans['short' + (player.details.Skill ? player.details.Skill : player.DBDetails.Skill)] }</span>
            </div> : null;
        }

        if (player.id === null) {
            return <div className={ jerseyClassName } { ...clickHandler }>
                <div className="si-data-wrap">
                    <div className="si-injury-icon si-active si-display-none">
                        <i className="icon-ucl-arrow_down" />
                        <div className="si-tooltip si-status-tooltip si-left-tt">
                            <span />
                        </div>
                    </div>
                    <span className="si-img-wrap" />
                    { playerActionIcon }
                    <div className="si-plyr-pos">{ this.props.trans['short' + player.DBDetails.Skill] }</div>
                    <div className="si-plyr-details si-selected">
                        <span className="si-plyr-name">{ player.DBDetails.PDName }</span>
                        <div className="si-plyr-val">
                            <span className="si-currency-font">{ this.props.trans.out }</span>
                        </div>
                    </div>
                    { subPos }
                </div>
            </div>
        } else {
            let pStatus = player.details.PStatus;
            let pStatusObj = config.playerStatusObj ? config.playerStatusObj : {};
            let pStatusHeaderClass = pStatusObj[pStatus] ? pStatusObj[pStatus]["playerInfoHeaderClass"] : '';
            const { userSpecificFixtures, currentActiveFixture } = this.props;
            if (userSpecificFixtures.length === 0) return null;
            const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
            let viewState = "";
            if (currentFixture) {
                viewState = getState(currentFixture);
            }

            if (viewState === config.possibleActions["live"] || viewState === config.possibleActions["viewpoint"]) {
                pStatusHeaderClass = "";
            }
            let hasStatus = pStatusHeaderClass != "";
            let playerStatusIcon = null;




            if (hasStatus) {
                let pStatusTransKey = pStatusObj[pStatus] ? pStatusObj[pStatus]["transKey"] : '';
                let jerseyClassObj = {
                    'si-active': showIconTooltip
                };
                jerseyClassObj[pStatusObj[pStatus]["playerJesreyClass"]] = true;
                jerseyClassObj[pStatusHeaderClass] = true;
                const jerseyStatusIconClass = common.makeClasses(jerseyClassObj);
                const iconTooltipClasses = common.makeClasses({
                    'si-tooltip': true,
                    'si-status-tooltip': true,
                    'si-left-tt': (playerIndex === 0),
                    'si-right-tt': (playerIndex === (this.props.numOfPlayers - 1)),
                });
                playerStatusIcon =
                    <div className={ jerseyStatusIconClass } >
                        <span className="si-status-icon" >
                            <div className="si-tooltip si-status-tooltip si-left-tt">
                                <span>
                                    {
                                        this.props.trans[pStatusObj[pStatus]['toolTipTrans']] || pStatusObj[pStatus]['status']
                                    }
                                </span>
                            </div>
                        </span>
                        { showIconTooltip ? <OutsideNotifier handler={ () => this.onFocusLost() }>
                            <div className={ iconTooltipClasses }>
                                <span>{ this.props.trans[pStatusTransKey] }</span>
                            </div>
                        </OutsideNotifier> : null }
                    </div>
            }
            const captainClass = isCaptain ? 'si-captain-icon' : '';
            const tooltipClass = isLast && 'si-' + isLast + '-tt';
            let priceStrip = <div className="si-plyr-val">
                <span className="si-currency-font">€</span>
                <span>{ player.details.Value }{ this.props.trans.million }</span>
            </div>;
            const UpComingMatchesList = player.details && player.details['UpComingMatchesList'] ? player.details['UpComingMatchesList'] : [];
            let vsObj = {};
            let vsTeam = '';
            if (UpComingMatchesList.length > 0) {
                vsObj = UpComingMatchesList[0];
            }

            let homeAwayIndctr = "";
            if (vsObj.hasOwnProperty('TLoc') && vsObj['TLoc'] != "" && vsObj['TLoc'] != null && vsObj['TLoc'] != undefined && vsObj['TLoc'] != "undefined") {
                homeAwayIndctr = "(" + vsObj['TLoc'] + ")"
            }

            if (vsObj.hasOwnProperty('VsCCode')) {
                vsTeam = vsObj['VsCCode'];
            }
            let vsStrip = <div className="si-plyr-val si-sml-fonts">
                <span>{ this.props.trans.vs_short } </span>
                <span className="si-vsStrip">{ vsTeam }{ homeAwayIndctr ? " " + homeAwayIndctr + " " : "" }</span>
            </div>;
            let playerBottomStrip = null;
            if (hasTransferView) {
                playerBottomStrip = priceStrip;
            } else if (hasManageView) {
                const TPoints = player.DBDetails.OverallPoints;
                const hasPoints = !(TPoints === undefined || TPoints === null || TPoints === "");
                if (hasPoints) {
                    const playerPointClasses = common.makeClasses({
                        "si-plyr-val": true,
                        "si-invalid-pts": isBench,
                        "si-minus-pts": !isBench && TPoints < 0,
                        "si-final-pts": !isBench && TPoints >= 0,
                    });
                    vsStrip = <div className={ playerPointClasses }>
                        { TPoints + ' ' + this.props.trans.labelPts }
                    </div>;
                }

                playerBottomStrip = (isFixtureUpdated) ? vsStrip : priceStrip;
            }
            // playerBottomStrip = priceStrip;  // price strip each time (TBD with Harsh)
            return <div className={ jerseyClassName }
                { ...clickHandler } data-skill={ player.skill } data-id={ player.id }>
                <div className={ dataWrapClass }>
                    { (hasManageView && tutorialFirstTime) ? tutorialTooltip : null }
                    { playerStatusIcon }
                    <span className={ "si-img-wrap " + captainClass } style={ { backgroundImage: "url(" + teamImg + ")" } } >
                        {
                            (isCaptain)
                                ?
                                <i className="icon-ucl-captain si-captain" onClick={ (e) => { this.onInfoTap(e, player.details, player) } }>
                                    <div className="si-tooltip si-status-tooltip si-tt">
                                        <span>{ this.props.trans['captainTT'] || "Captain" }</span>
                                    </div>
                                </i>
                                :
                                null
                        }
                    </span>
                    { playerActionIcon }
                    {/* {moreOptions ? ((hasManageView) ?
                        <OutsideNotifier handler={() => this.onFocusLost()}>
                            {this.getTooltipMarkup(player, tooltipClass, objKey, playerIndex)}
                        </OutsideNotifier> : null) : null} */}
                    { captainTooltip ?
                        <OutsideNotifier handler={ () => this.onFocusLostCaptainTooltip() }>
                            <div className={ "si-tooltip si-captain-tooltip si-flexBox " + tooltipClass }>
                                <span>{ this.props.trans['captain_will_get'] }</span></div>
                        </OutsideNotifier> : null }
                    <div className="si-plyr-pos">{ this.props.trans['short' + player.skill] }</div>
                    <div className="si-plyr-details">
                        <span className="si-plyr-name">{ player.details['PDName'] }</span>
                        { playerBottomStrip }
                    </div>
                    { subPos }
                </div>
            </div>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        hasSeenManageTeamTutorial: state.formationData.hasSeenManageTeamTutorial,
        teamData: state.formationData.teamData,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
        manageTeamMode: state.formationData.manageTeamMode,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
        setHighlight: (obj) => dispatch(setHighlight(obj)),
        makeCaptain: (obj, objKey, playerIndex) => dispatch(makeCaptain(obj, objKey, playerIndex)),
        removePlayer: (obj) => dispatch(removePlayer(obj)),
        addOrRemovePlayer: (player) => dispatch(addOrRemovePlayer(player)),
        setManageTeamTutorialCookie: () => dispatch(setManageTeamTutorialCookie()),
        triggerHandlePlayerCard: (isPlayerCardVisible, playerObj) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, playerObj)),
        setManageTeamMode: (mode) => dispatch(setManageTeamMode(mode)),
        initiateSubstitution: (player) => dispatch(initiateSubstitution(player)),
        resetAllFilters: () => dispatch(resetAllFilters()),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JerseyManageTeam));


// WEBPACK FOOTER //
// ./src/components/manage-team/Jersey-ManageTeam.js